var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfficeAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.9999,
    cy: 50,
    r: 47.619,
    fill: "#E2F3F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2188 78.2668C37.6401 78.2721 35.058 78.2774 32.4793 78.2668C28.5232 78.2491 25.8841 75.5864 25.8789 71.6155C25.8737 66.1131 25.8789 60.6125 25.8789 55.112V54.1914H25.8771C25.1073 54.1365 24.4342 54.163 23.7921 54.0356C21.3653 53.5523 19.6945 52.1183 19.023 49.7282C18.324 47.2373 18.9902 45.0385 20.8958 43.277C24.4411 40.0035 28.0036 36.7513 31.5593 33.4903C36.2748 29.1635 40.9904 24.8367 45.7059 20.5116C48.257 18.1729 51.8178 18.1588 54.381 20.4992C62.6315 28.0357 70.8785 35.5758 79.1221 43.1212C81.1053 44.9376 81.7612 47.6321 80.8361 50.0735C79.8988 52.5502 77.6222 54.1099 74.8933 54.1383C74.6724 54.14 74.4549 54.1383 74.1131 54.1383V55.0305C74.1131 60.5311 74.1166 66.0335 74.1131 71.534C74.1097 75.6502 71.4913 78.265 67.3798 78.2704C64.8736 78.2704 62.3674 78.2774 59.8629 78.2704H40.2188V78.2668Z",
    fill: "#307F92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0012 40.4439C53.671 40.4439 58.2603 37.657 60.0944 42.3007C60.9852 44.5549 59.9467 49.2148 58.0046 53.4138C58.165 54.8162 58.2587 56.4075 58.2587 58.0916C58.2587 63.7353 57.2328 68.3105 55.9641 68.3105C52.6087 68.3105 55.7338 56.2348 49.9996 56.2348C44.2654 56.2348 47.3143 68.3105 44.0352 68.3105C42.7679 68.3105 41.7421 63.7353 41.7421 58.0916C41.7421 56.4075 41.8342 54.8162 41.9962 53.4138C40.0557 49.2148 39.0156 44.5549 39.9048 42.3007C41.7405 37.657 46.3282 40.4439 49.998 40.4439H50.0012Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeAvatar);
export default __webpack_public_path__ + "static/media/office-avatar.dd3605400ae3047ce014e9e3d8cd77d0.svg";
export { ForwardRef as ReactComponent };